import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Truck, Snowflake, Package } from 'lucide-react';

export const WhoWeServeSection = () => {
  const equipment = [
    {
      icon: Truck,
      title: "Dry Van",
      description: "Standard freight hauling with reliable load matching and competitive rates."
    },
    {
      icon: Snowflake,
      title: "Reefer",
      description: "Temperature-controlled transport with premium rates and specialized support."
    },
    {
      icon: Package,
      title: "Hotshot/Box Truck",
      description: "Expedited delivery services with quick turnarounds and flexible scheduling."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Who We Serve</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Owner-operators and small fleets running diverse equipment types across the nation.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {equipment.map((item, index) => (
            <Card key={index} className="hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-gray-100 hover:border-blue-200">
              <CardHeader className="text-center pb-4">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <item.icon className="h-8 w-8 text-blue-600" />
                </div>
                <CardTitle className="text-xl font-bold text-gray-900">{item.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-50 to-orange-50 rounded-3xl p-8 md:p-12 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">Results & Benefits</h3>
          <div className="grid md:grid-cols-3 gap-8 text-left">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h4 className="text-xl font-semibold text-blue-900 mb-3">Higher $/Mile</h4>
              <p className="text-gray-600">Smarter lane selection and rate negotiation to maximize your earnings per mile.</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h4 className="text-xl font-semibold text-blue-900 mb-3">Less Admin Time</h4>
              <p className="text-gray-600">Faster turnarounds with streamlined paperwork and booking processes.</p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h4 className="text-xl font-semibold text-blue-900 mb-3">Consistent Backhauls</h4>
              <p className="text-gray-600">Reduced deadhead miles with strategic load planning and route optimization.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};